module.exports = __webpack_public_path__ + "img/9c5285e27b3702b7e057710334ae4ca.0d0199bc.jpg";